import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Row, Col, Container, Button, Spinner, Form } from 'react-bootstrap';
import { convertNormaltoTokenAmount } from '../components/blockchain functions/BlockchainFunctions';//API to get Data from wave account

import { exchangeToken } from "../components/contract functions/Exchange";
import { LoginContext } from "../context/LoginContext";
//icons
import errSad from '../components/assets/err_sad.jpg';

const ExchangeToken = () => {
  const history = useHistory();

  const [loginData, setLoginData] = useContext(LoginContext);
  const [loading, setLoading] = useState(false);//Loading bar
  const [timer, setTimer] = useState(10);
  const [score, setScore] = useState(0);
  const [selectedValue, setSelectedValue] = useState(0);

  const startCountdown = () => {
    var i = 10;
    var countdown = setInterval(function () {
      setTimer(i);
      i--;
      if (i < 0) {
        clearInterval(countdown);
        toast.info("Start");
      }
    }, 1000);
  }


  return (
    <>
      <Row>
        <Col md={6}>
          <div className="page-heading">
            <h1>Awww... Don't Cry.</h1>
            <h3>It's just a 404 Error</h3>
            <br />
            <p>It seems you entered a wrong url and landed up on a wrong page.
              <br /> Please <a href="/">Click Here</a> for home page.</p>
          </div>
        </Col>
        <Col md={6}>
          <img style={{ width: "100%" }} src={errSad} />
        </Col>
      </Row>
      <hr />
      
      <br /><br /><br /><br />
    </>

  )
}

export default ExchangeToken